var map = {
	"./feedback/empty-notes.svg": "5d01",
	"./feedback/message-fail.svg": "dcf8",
	"./feedback/message-sent.svg": "7f99",
	"./gender/female-placeholder.svg": "b6fc",
	"./gender/gender-icons/female.svg": "4714",
	"./gender/gender-icons/male.svg": "b4aa",
	"./gender/gender-icons/non_binary.svg": "bc58",
	"./gender/gender-icons/other.svg": "ddfd",
	"./gender/gender-icons/prefer_not_specify.svg": "308c",
	"./gender/male-placeholder.svg": "4689",
	"./gender/non_binary-placeholder.svg": "a895",
	"./gender/unknown-placeholder.svg": "80a6",
	"./general/info.svg": "9a1b",
	"./goals/article.svg": "dfb6",
	"./goals/exercise-routine.svg": "dc2a",
	"./goals/goal.svg": "c34c",
	"./goals/mental-health.svg": "b58c",
	"./goals/no-medication.svg": "2398",
	"./goals/no-pain.svg": "f927",
	"./goals/no-surgery.svg": "fbc2",
	"./goals/shield-alt.svg": "4d53",
	"./goals/sleep.svg": "3cb7",
	"./goals/strength.svg": "0c1b",
	"./goals/target.svg": "258c",
	"./goals/tennis.svg": "a027",
	"./spinners/loader.svg": "8cbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d08";